import { type PlainObject } from '@graphql-box/core';
import { type ConnectionResponse } from '@graphql-box/react';
import { get } from 'lodash-es';

export const extractNodesFromConnectionResponse = <Item extends PlainObject>(
  res: ConnectionResponse<Item> | null | undefined,
  requestPath: string,
): Item[] => {
  if (!res) {
    return [];
  }

  const requestPathData = get(res, requestPath);

  if (!requestPathData) {
    return [];
  }

  const { edges } = requestPathData;

  if (!edges?.length) {
    return [];
  }

  return edges.map(edge => edge.node);
};
